import {
  type Dispatch,
  type SetStateAction,
  useCallback,
  useState,
} from 'react';

export type PagesProps = {
  value: number[];
  setValue: Dispatch<SetStateAction<number[]>>;
  setNext: () => void;
  setPrevious: () => void;
  toggle: (params: number) => void;
};

export const usePages = (): PagesProps => {
  const [value, setValue] = useState([3, 4, 5]);

  const setNext = useCallback(() => {
    setValue(value.map((item: number) => item + 1));
  }, [value]);

  const setPrevious = useCallback(() => {
    setValue(value.map((item: number) => item - 1));
  }, [value]);

  const toggle: PagesProps['toggle'] = (params) => {
    if (params > 4) setValue([params - 1, params, params + 1]);
    else setValue([3, 4, 5]);
  };

  return { value, setValue, setNext, setPrevious, toggle };
};
